import { Grid, Input, Select, Space } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import type { Dispatch } from 'react';
import { IMaskInput as Mask } from 'react-imask';
import { useReturnDetailsForm } from '../hooks/useReturnDetailsForm';
import type { VatDetails, VatReturnInputs } from '../types/VatReturn';
import { ButtonOrCancel } from './VatReturnExportModal';

interface ReturnDetailsFormProps {
	setSelectedPage: Dispatch<React.SetStateAction<number>>;
	setInputsInParent: Dispatch<React.SetStateAction<VatReturnInputs>>;
	closeAndResetModal: () => void;
	currentDetails?: VatDetails;
}

export function ReturnDetailsForm({
	setSelectedPage,
	setInputsInParent,
	closeAndResetModal,
	currentDetails: currentInputs,
}: ReturnDetailsFormProps) {
	const { form, inputs } =
		useReturnDetailsForm(currentInputs);

	return (
		<form
			onSubmit={form.onSubmit(() => {
				form.validate();
			})}
		>
			<Grid>
				<Grid.Col span={4}>
					<Input.Wrapper
						label={'Registration Number'}
						key={form.key('registrationNumber')}
						{...form.getInputProps('registrationNumber')}
					>
						<Input
							component={Mask}
							mask={'GB 000 00 00 00'}
							placeholder="Registration number..."
							key={form.key('registrationNumber')}
							{...form.getInputProps('registrationNumber')}
						/>
					</Input.Wrapper>
				</Grid.Col>
				<Grid.Col span={4}>
					<Select
						key={form.key('vatScheme')}
						{...form.getInputProps('vatScheme')}
						label={'VAT Scheme'}
						placeholder="Select VAT Scheme..."
						data={['Cash Scheme']}
						clearable
					/>
				</Grid.Col>
				<Grid.Col span={4}>
					<Select
						key={form.key('periodType')}
						{...form.getInputProps('periodType')}
						label={'Period Covered'}
						placeholder="Select period covered..."
						data={['Yearly', 'Biyearly', 'Quaterly', 'Custom']}
						clearable
					/>
				</Grid.Col>
				<Grid.Col span={6}>
					<DatePickerInput
						key={form.key('startDate')}
						{...form.getInputProps('startDate')}
						label={'Start Date'}
						placeholder="Choose start date..."
					/>
				</Grid.Col>
				<Grid.Col span={6}>
					<DatePickerInput
						key={form.key('endDate')}
						{...form.getInputProps('endDate')}
						label={'End Date'}
						placeholder="Choose end date..."
					/>
				</Grid.Col>
				<Grid.Col span={12}>
					<DatePickerInput
						key={form.key('deadline')}
						{...form.getInputProps('deadline')}
						label={'Deadline For Submitting Return'}
						placeholder="Deadline for submitting return..."
					/>
				</Grid.Col>
			</Grid>
			<Space h={20} />
			<ButtonOrCancel
				closeAndReset={() => closeAndResetModal()}
				onGoBack={(): void => {
					throw new Error('Function not implemented.');
				}}
				onClick={() => {
					if (form.isValid()) {
						setInputsInParent((prevInputs) => ({
							...prevInputs,
							details: inputs,
						}));
						setSelectedPage(1);
					}
				}}
			/>
		</form>
	);
}
